import { formatEther } from "viem";

function formatRewards(value: bigint, toFixed = 2) {
	return value ? commify(Number(formatEther(value)).toFixed(toFixed)) : "0";
}
export function commify(value: string | number): string {
	const comps = String(value).split(".");

	if (
		comps.length > 2 ||
		!/^-?\d*$/.test(comps[0]) ||
		(comps[1] && !/^\d*$/.test(comps[1])) ||
		value === "." ||
		value === "-."
	) {
		throw new Error(`invalid value', 'value', ${value}`);
	}
	let whole = comps[0];

	let negative = "";
	if (whole.slice(0, 1) === "-") {
		negative = "-";
		whole = whole.slice(1);
	}
	while (whole.slice(0, 1) === "0") {
		whole = whole.slice(1);
	}
	if (whole === "") {
		whole = "0";
	}

	let suffix = "";
	if (comps.length === 2) {
		suffix = `.${comps[1] || "0"}`;
	}
	while (suffix.length > 2 && suffix.at(-1) === "0") {
		suffix = suffix.slice(0, Math.max(0, suffix.length - 1));
	}

	const formatted = [];
	while (whole.length > 0) {
		if (whole.length <= 3) {
			formatted.unshift(whole);
			break;
		}
		const index = whole.length - 3;
		formatted.unshift(whole.slice(Math.max(0, index)));
		whole = whole.slice(0, Math.max(0, index));
	}

	return negative + formatted.join(",") + suffix;
}

export function formatIntlNumber(
	number: string | number,
	location,
	options: Intl.NumberFormatOptions,
) {
	return new Intl.NumberFormat(location, options).format(Number(number));
}

/**
 * @description Use this whenever you would like to display a formated number.
 */
export function formatNumber(number: string | number, location = "en-US") {
	return formatIntlNumber(number, location, { maximumFractionDigits: 3 });
}

/**
 * @description Use this whenever you would like to display a currency.
 */
export function formatCurrency(number: string | number, location = "en-US") {
	return formatIntlNumber(number, location, {
		currency: "USD",
		maximumFractionDigits: 5,
		style: "currency",
	});
}

export default formatRewards;
